// extracted by mini-css-extract-plugin
export var modalFooter = "_pj-0";